import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { CustomerFilterLanguage } from 'src/app/core/class/customer-filter-language';
import { Component, OnInit, ViewChild, OnDestroy, ViewChildren, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomerService } from 'src/app/core/services/customer.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { CommonService } from 'src/app/core/services/common.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from 'src/app/core/services/storage.service';
import { EnterpriseTypes } from 'src/app/core/constants/enterprise-type';
import { FormControl } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { NgForm} from '@angular/forms';
import { MatOption, MatSelect } from '@angular/material';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NotifyExportDataCustomerComponent } from 'src/app/shared/components/notify-export-data-customer-dialog/notify-export-data-customer-dialog.component';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { NotifyExportDataCustomerSuccessComponent } from 'src/app/shared/components/notify-export-data-customer-success-dialog/notify-export-data-customer-success-dialog.component';
import { EnvService } from 'src/app/core/services/env.service';
import { DocumentKeyPair, PaginateKeyPair, SortKeyPair } from '../document-type/document-type.component';
import { ResponsiveService } from 'src/app/core/services/responsive.service';
import { DeleteAllCustomersDialogComponent } from '../document/delete-all-customers-dialog/delete-all-customers-dialog.component';
import { DialogSyncCustomerComponent } from '../customer/customer/dialog-sync-customer/dialog-sync-customer.component';
import { EnterpriseService } from 'src/app/core/services/enterprise.service';

@Component({
  selector: 'app-enterprise-action-log',
  templateUrl: './enterprise-action-log.component.html',
  styleUrls: ['./enterprise-action-log.component.scss']
})
export class EnterpriseActionLogComponent implements OnInit {

   @ViewChild('allSelectedGroup', { static: false }) allSelectedGroup: MatOption;
    @ViewChild('groupSelect', { static: false }) groupSelect: MatSelect;
    @ViewChild('myForm', {static: false}) ngForm: NgForm;
    enterpriseActionLog = {
      enterpriseId: localStorage.getItem('enterpriseId'),
      tenantId: localStorage.getItem('tenantId'),
      account: '',
      action: '',
      deviceType: '',
      createdTimeFrom: null,
      createdTimeTo: null,
      errorCode: '',
      errorDescription: '',
      ip: '',
      objectAction: '',
      status: ''
    };
    isBasicSearchForm = true;
    createdDateErr = '';
   finishedDateErr = '';
    group = {
      id: [],
      createdTime: '',
      description: '',
      name: '',
    }
  
    // dataSource: DocumentDataSource;
    checkAll: boolean;
    enterpriseType: comboBox[] = [];
    dataSelected: Map<any, Document> = new Map<any, Document>();
    documents = new Document();
    parentDocuments: Document[];
    childOldDataList: DocumentKeyPair = {};
    childPaginateList: PaginateKeyPair = {};
    childSortList: SortKeyPair = {};
    childIsExpanding: Array<string>;
    groupData: comboBox[] = [];
    GroupCustomersId = []
    GroupCustomersFilterCtrl: FormControl = new FormControl();
    public filteredGroupCustomers: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  
    enterpriseTypeFilterCtrl: FormControl = new FormControl();
  
    public filteredEnterpriseType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
    private _onDestroy = new Subject<void>();
  
    checkFocus = true;
    enterpriseList: any;
    // displayedColumns: string[] = ['id', 'name', 'certificateNo', 'address', 'email', 'phone', 'symbol'];
    displayedColumns: string[] = [];
  
    columnDefinitions = [
      { def: "id", showMobile: true },
      { def: "account", showMobile: true },
      { def: "action", showMobile: true },
      { def: "deviceType", showMobile: true },
      { def: "errorCode", showMobile: true },
      { def: "errorDescription", showMobile: false },
      { def: "ip", showMobile: false },
      { def: "objectAction", showMobile: false },
      { def: "status", showMobile: true },
      { def: "createdAt", showMobile: true },
    ];
  
    dataSource: MatTableDataSource<any> = new MatTableDataSource();
    oldData = this.enterpriseActionLog;
    paginate: {
      currentPage: number,
      pageSize: number,
      totalRow: number,
      totalPage: number,
      totalPageArray: [],
      no: []
    };
    cities: { id: number, name: '', description: '' }[];
    districts: { id: number, cityId: number, name: '', description: '' }[];
    wards: { id: number, districtId: number, name: '', description: '' }[];
    error = '';
    subscription: Subscription;
    personalId = EnterpriseTypes.PERSONAL;
    permissions: any;
    userId: any;
  
    // Variable for saving userType from session storage of current user
    userType: number;
    enterpriseTypeI18n = new Map();
  
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChildren('focusInput') focusInput;
    @ViewChild('enterpriseTypeSelect', { static: false }) enterpriseTypeSelect: MatSelect;
    public enterpriseId: string;
  
    public mediaBreakpoint: any;
    public subscribeMediaBreakPointService: Subscription;
    public SCREEN_SIZE = SCREEN_SIZE;
    isNotAttestedUser: boolean = false;
    isBuyTwoService: boolean = false
    isDefaultAdmin: boolean = false
    sme_hub:any;
    constructor(
      public notificationService: NotificationService,
      public dialog: MatDialog,
      private customerService: CustomerService,
      private enterpriseService: EnterpriseService,
      public commonService: CommonService,
      private route: ActivatedRoute,
      private router: Router,
      private message: Message,
      private toastr: ToastrService,
      private storageService: StorageService,
      public customerFilter: CustomerFilterLanguage,
      private responsiveService: ResponsiveService,
      public deviceService: DeviceDetectorService,
      private env:EnvService
    ) {
      this.isNotAttestedUser = this.commonService.checkEnterpriseType();
      this.isBuyTwoService = this.commonService.checkBuyTwoServiceWithoutHauntAndAdminAndPermissionCustomer();
      this.isDefaultAdmin = this.commonService.checkDefaultAdmin()
      this.paginate = {
        currentPage: 0,
        pageSize: 10,
        totalRow: 0,
        totalPage: 0,
        totalPageArray: [],
        no: []
      };
      this.permissions = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : [];
      this.userId = localStorage.getItem('userId');
      this.enterpriseId = localStorage.getItem('enterpriseId');;
      this.sme_hub = env.sme_portal_url
    }
  
    /**
     * Get initial data
     */
    ngOnInit() {
      this.onFilterCustomers();
      window.scrollTo(0, 0);
    }
  
    ngAfterViewInit() {
      setTimeout(_ => this.focusInput.first.nativeElement.focus());
      this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
        media => {
          if (media === '') {
            this.mediaBreakpoint = '';
            return;
          } else {
            this.mediaBreakpoint = media;
            this.getDisplayedColumns();
          }
        }
      );
    }
  
  
  
    clickOptionServiceType() {
      // if (this.documents.serviceTypeId[0] === -1 && this.documents.serviceTypeId.length > 1) {
      //   this.documents.serviceTypeId = this.documents.serviceTypeId.filter(id => id !== -1);
      // }
  
      if (this.allSelectedGroup.selected) {
        this.allSelectedGroup.deselect();
      }
      if (this.groupSelect.options.length - 2 == this.group.id.length) {
        this.allSelectedGroup.select();
      }
    }
  
    /**
     * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
     */
    ngOnDestroy() {
      this.notificationService.unsubscribeErrorService();
      this.subscribeMediaBreakPointService.unsubscribe();
    }
  
    setValueI18nToMap() {
      this.enterpriseTypeI18n.set(10000, 'enterprise_customer_management.cbx_custommer_type.cbx_custommer_type_personal');
      this.enterpriseTypeI18n.set(10001, 'enterprise_customer_management.cbx_custommer_type.cbx_custommer_type_private_company');
      this.enterpriseTypeI18n.set(10002, 'enterprise_customer_management.cbx_custommer_type.cbx_custommer_type_authority');
      this.enterpriseTypeI18n.set(10003, 'enterprise_customer_management.cbx_custommer_type.cbx_custommer_type_government_agencies');
      this.enterpriseTypeI18n.set(10004, 'enterprise_customer_management.cbx_custommer_type.cbx_custommer_state_enterprise');
      this.enterpriseTypeI18n.set(10005, 'enterprise_customer_management.cbx_custommer_type.cbx_individual_business_households');
    }
  
  
    getDisplayedColumns() {
      if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
        this.displayedColumns = this.columnDefinitions
          .filter(cd => cd.showMobile)
          .map(cd => cd.def);
      } else {
        this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
      }
      // if (this.commonService.getIsLockedEnterprise()) {
      //   this.displayedColumns = this.columnDefinitions
      //     .filter(cd => (cd.def !== 'action' && cd.def !== 'status' && cd.def !== 'check'))
      //     .map(cd => cd.def);
      // }
    }
  
  
    /**
     * Filter customer
     */
  
    onFilterCustomers(page: number = 0, pageSize: number = 10) {
      let status: any[] = [];
      if (this.enterpriseActionLog.status == null || this.enterpriseActionLog.status === "") {
    status = [true, false]; 
  } else {
    status = [this.enterpriseActionLog.status];
  }
  
      if ((this.userType !== -1 && this.userType !== 2) || this.checkDisplayFullList()) {
        const body: any = {
          ...this.enterpriseActionLog,
          page,
          pageSize,
          enterpriseId: localStorage.getItem('enterpriseId'),
          status
        }
        this.enterpriseService.filterEnterpriseActionLog(
          body
       ).subscribe(
          rs => {
            console.log('30945834905834095348095 onFilterCustomers');
            this.bindData(rs);
          }
        );
      } else if (this.userType === 2 && !this.checkDisplayFullList()) {
        this.customerService.filterCustomersForGuest({
          tenantId: localStorage.getItem('tenantId'),
          page,
          pageSize,
        }).subscribe(
          rs => {
            this.bindData(rs);
          }
        );
      }
    }
  
    getStatusView(value: boolean) {
  const foundItem = this.lstStatus.find(e => e.value === value);
  return foundItem ? foundItem.view : undefined;
}

lstStatus = [ 
  {
    value: true,
    view: 'Thành công'
  },
  {
    value: false,
    view: 'Thất Bại'
  }  
];
  
    checkCheckAll() {
      let data = this.dataSource.data;
      for (let i = 0; i < data.length; i++) {
        const currentRow = data[i];
        if (!this.dataSelected.has(currentRow.id)) {
          this.checkAll = false;
          break;
        }
        if (i === data.length - 1) {
          this.checkAll = true;
        }
      }
    }
  
  
  
    /**
     * Bind data from api
     */
    private bindData(rs: any) {
      console.log('rs bindData', rs)
      if (rs == null || rs.data == null || rs.data.dataRow == null) {
        return 0;
      }
      this.paginate = {
        currentPage: rs.data.currentPage,
        pageSize: rs.data.pageSize,
        totalRow: rs.data.totalRow,
        totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
        totalPageArray: this.commonService.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
        no: this.commonService.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
      };
      this.dataSource.data = rs.data.dataRow;
      // if (this.cities !== undefined && this.districts !== undefined && this.wards !== undefined) {
      //   this.dataSource.data = this.dataSource.data.map((x: any) => {
      //     return {
      //       ...x,
      //       address: x.address + `, ${this.commonService.getWardName(this.wards, x.wardId).name}, ${this.commonService.getDistrictName(this.districts, x.districtId).name}, ${this.commonService.getCityName(this.cities, x.cityId).name}`
      //     };
      //   });
      // }
      /* đối chiếu list mới trả về và danh sách object đã check */
      // nếu mà map object đã check tồn tại ở trong list hiện => chuyển trạng thái thành checked = true
      // this.initParent(rs);
      // this.checkCheckAll();
    }
  
    /**
     * Bind old search data to variable oldData to avoid error
     */
    onClickBtnFilter() {
      this.oldData = { ...this.enterpriseActionLog };
    }
  
    /**
     * Open advanced search form
     */
    onExpandAdvancedSearchForm() {
      this.isBasicSearchForm = false;
      setTimeout(_ => this.focusInput.first.nativeElement.focus());
    }
  
    /**
     * Close advanced search form
     */
    onCloseAdvancedSearchForm() {
      this.isBasicSearchForm = true;
      setTimeout(_ => this.focusInput.first.nativeElement.focus());
    }
  
    /**
     *
     */
    onClickBtnAdd() {
      // changes the route without moving from the current view or
      // triggering a navigation event,
      this.router.navigate(['/home-enterprise/add-customer'], {
      });
    }
  
 
  
    getEnterpriseTypeOptions(options) {
      return this.customerFilter.filterOptionsData(options);
    }
  
  
    checkDisplayFullList() {
      if(this.isDefaultAdmin) {
        return true;
      }
      if(this.permissions.includes(402) || this.permissions.includes(403) || this.permissions.includes(4)) {
        return true;
      }
      return false;
    }

  

}
